<template><section><h2>基础坐标轴</h2>
<block-demo tip="基础坐标" source="const data = [
  { month: &#39;Jan&#39;, city: &#39;London&#39;, value: 3.9 },
  { month: &#39;Feb&#39;, city: &#39;London&#39;, value: 4.2 },
  { month: &#39;Mar&#39;, city: &#39;London&#39;, value: 5.7 },
  { month: &#39;Apr&#39;, city: &#39;London&#39;, value: 8.5 },
  { month: &#39;May&#39;, city: &#39;London&#39;, value: 11.9 },
  { month: &#39;Jun&#39;, city: &#39;London&#39;, value: 15.2 }
]

const { Chart, Axis, Line } = qcharts

const chart = new Chart({
  container: &#39;#app&#39;,
  size: [&#39;100%&#39;, &#39;100%&#39;]
}).source(data, {
  row: &#39;city&#39;,
  value: &#39;value&#39;,
  text: &#39;month&#39;
})

const line = new Line().style(&#39;point&#39;, { color: &#39;#fff&#39; })

let xAxis = new Axis({})
  .style(&#39;label&#39;, function(attrs, data, i) {
    if (i % 2 === 0) {
      return false
    } else {
      if (data.text.indexOf(&#39;A&#39;) === 0) {
        return {
          rotate: 45,
          translate: [-5, -5],
          anchor: [0, 0],
          color: &#39;#00f&#39;
        }
      } else {
        return { color: &#39;#f00&#39; }
      }
    }
  })
  .style(&#39;scale&#39;, function(attrs, data, i) {
    if (i % 2 === 0) {
      return false
    }
  })
let yAxis = new Axis({ orient: &#39;left&#39; })

chart.append([line, xAxis, yAxis])
"><pre v-pre><code v-pre class="language-javascript"><span class="hljs-keyword">const</span> data = [
  { <span class="hljs-attr">month</span>: <span class="hljs-string">'Jan'</span>, <span class="hljs-attr">city</span>: <span class="hljs-string">'London'</span>, <span class="hljs-attr">value</span>: <span class="hljs-number">3.9</span> },
  { <span class="hljs-attr">month</span>: <span class="hljs-string">'Feb'</span>, <span class="hljs-attr">city</span>: <span class="hljs-string">'London'</span>, <span class="hljs-attr">value</span>: <span class="hljs-number">4.2</span> },
  { <span class="hljs-attr">month</span>: <span class="hljs-string">'Mar'</span>, <span class="hljs-attr">city</span>: <span class="hljs-string">'London'</span>, <span class="hljs-attr">value</span>: <span class="hljs-number">5.7</span> },
  { <span class="hljs-attr">month</span>: <span class="hljs-string">'Apr'</span>, <span class="hljs-attr">city</span>: <span class="hljs-string">'London'</span>, <span class="hljs-attr">value</span>: <span class="hljs-number">8.5</span> },
  { <span class="hljs-attr">month</span>: <span class="hljs-string">'May'</span>, <span class="hljs-attr">city</span>: <span class="hljs-string">'London'</span>, <span class="hljs-attr">value</span>: <span class="hljs-number">11.9</span> },
  { <span class="hljs-attr">month</span>: <span class="hljs-string">'Jun'</span>, <span class="hljs-attr">city</span>: <span class="hljs-string">'London'</span>, <span class="hljs-attr">value</span>: <span class="hljs-number">15.2</span> }
]

<span class="hljs-keyword">const</span> { Chart, Axis, Line } = qcharts

<span class="hljs-keyword">const</span> chart = <span class="hljs-keyword">new</span> Chart({
  <span class="hljs-attr">container</span>: <span class="hljs-string">'#app'</span>,
  <span class="hljs-attr">size</span>: [<span class="hljs-string">'100%'</span>, <span class="hljs-string">'100%'</span>]
}).source(data, {
  <span class="hljs-attr">row</span>: <span class="hljs-string">'city'</span>,
  <span class="hljs-attr">value</span>: <span class="hljs-string">'value'</span>,
  <span class="hljs-attr">text</span>: <span class="hljs-string">'month'</span>
})

<span class="hljs-keyword">const</span> line = <span class="hljs-keyword">new</span> Line().style(<span class="hljs-string">'point'</span>, { <span class="hljs-attr">color</span>: <span class="hljs-string">'#fff'</span> })

<span class="hljs-keyword">let</span> xAxis = <span class="hljs-keyword">new</span> Axis({})
  .style(<span class="hljs-string">'label'</span>, <span class="hljs-function"><span class="hljs-keyword">function</span>(<span class="hljs-params">attrs, data, i</span>) </span>{
    <span class="hljs-keyword">if</span> (i % <span class="hljs-number">2</span> === <span class="hljs-number">0</span>) {
      <span class="hljs-keyword">return</span> <span class="hljs-literal">false</span>
    } <span class="hljs-keyword">else</span> {
      <span class="hljs-keyword">if</span> (data.text.indexOf(<span class="hljs-string">'A'</span>) === <span class="hljs-number">0</span>) {
        <span class="hljs-keyword">return</span> {
          <span class="hljs-attr">rotate</span>: <span class="hljs-number">45</span>,
          <span class="hljs-attr">translate</span>: [<span class="hljs-number">-5</span>, <span class="hljs-number">-5</span>],
          <span class="hljs-attr">anchor</span>: [<span class="hljs-number">0</span>, <span class="hljs-number">0</span>],
          <span class="hljs-attr">color</span>: <span class="hljs-string">'#00f'</span>
        }
      } <span class="hljs-keyword">else</span> {
        <span class="hljs-keyword">return</span> { <span class="hljs-attr">color</span>: <span class="hljs-string">'#f00'</span> }
      }
    }
  })
  .style(<span class="hljs-string">'scale'</span>, <span class="hljs-function"><span class="hljs-keyword">function</span>(<span class="hljs-params">attrs, data, i</span>) </span>{
    <span class="hljs-keyword">if</span> (i % <span class="hljs-number">2</span> === <span class="hljs-number">0</span>) {
      <span class="hljs-keyword">return</span> <span class="hljs-literal">false</span>
    }
  })
<span class="hljs-keyword">let</span> yAxis = <span class="hljs-keyword">new</span> Axis({ <span class="hljs-attr">orient</span>: <span class="hljs-string">'left'</span> })

chart.append([line, xAxis, yAxis])
</code></pre>
</block-demo></section></template><script>export default {components:{}}</script>